export enum ProfessionExperienceLevel {
  Internship = 0,
  Starter = 1,
  Experienced = 2,
  Expert = 3,
}

export enum VacancyStatus {
  Draft = 0,
  Active = 1,
  Closed = 2,
  Archived = 3,
}

export enum VacancyLayoutVersion {
  V1 = 0,
  V2 = 1,
}

export enum HoursPerWeek {
  H0_8 = 0,
  H9_16 = 1,
  H17_24 = 2,
  H25_32 = 3,
  H33_36 = 4,
  H37_40Plus = 5,
  Parttime = 6,
  Fulltime = 7,
  Flexible = 8,
}

export enum Shift {
  Weekends = 0,
  Evenings = 1,
  Flexible = 2,
  Dayshift = 3,
  Shiftwork = 4,
}

export enum VacancyCandidates {
  One = 0,
  Two = 1,
  Three = 2,
  Four = 3,
  Five = 4,
}

export enum EmploymentType {
  Pernament = 0,
  Temporary = 1,
  PernamentPossible = 2,
  Delegation = 3,
  Parttime = 4,
  Intership = 5,
  Volunteering = 6,
  Training = 7,
  Freelance = 8,
}

export enum RemoteWork {
  Yes1DayAWeek = 0,
  Yes2DaysAWeek = 1,
  YesMoreThan2DaysAWeek = 2,
  Full = 3,
  No = 4,
}

export enum Distance {
  Unknown = 0,
  Upto10km = 1,
  Upto25km = 2,
  Upto50km = 3,
  Any = 4,
}

export enum SalaryPeriod {
  Monthly = 0,
  Yearly = 1,
}

export enum SalaryAmountType {
  PerHour = 0,
  Range = 1,
}

export enum VacancySearchMode {
  Search = 0,
  ByWorkExperience = 1,
  ByDreamProfessions = 2,
  SurpriseMe = 3,
}

export enum HoursPerWeekPreference {
  H0_24 = 0,
  H24_32 = 1,
  H32_40 = 2,
  HFlexible = 3,
  HParttime = 4,
}

export enum PostingDate {
  All = 0,
  Today = 1,
  OneWeek = 2,
  OneMonth = 3,
}

export enum VacancySortOrder {
  Match = 0,
  Date = 1,
  Salary = 2,
}

export enum UserPreferredEducationLevel {
  Lbo = 0,
  Vmbo = 1,
  Havo = 2,
  Vwo = 3,
  Mbo = 4,
  Hbo = 5,
  Wo = 6,
  Phd = 7,
}
